import { c as _c } from "react/compiler-runtime";
import { InlineAlert } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import AnimatedContainer from '@/components/animated-container';
import type { TransformedDocument } from '@/components/entities/components/details/hooks/use-documents';
import type useEntityVault from '@/components/entities/hooks/use-entity-vault';
import AgentExtractionData from './components/agent-extraction-data';
import ConfidenceScores from './components/confidence-scores';
import ExtractedDocumentData from './components/extracted-document-data';
import IdentityData from './components/identity-data';
import RawJsonData from './components/raw-json-data';
import useAgentExtractionResult from './hooks/use-agent-extraction-result';
export type DrawerContentProps = {
  document: TransformedDocument;
  vault: ReturnType<typeof useEntityVault>;
};
const DrawerContent = t0 => {
  const $ = _c(32);
  const {
    document,
    vault
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "fieldset.documents.details"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const {
    extractions,
    hasExtractionData
  } = useAgentExtractionResult(document.id);
  const isFixtureData = document.fixtureResult && document.fixtureResult !== "real";
  let t2;
  if ($[1] !== vault.data?.vault) {
    t2 = vault.data?.vault || {};
    $[1] = vault.data?.vault;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const vaultData = t2;
  let t3;
  if ($[3] !== document.completedVersion) {
    t3 = document.completedVersion?.toString();
    $[3] = document.completedVersion;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const activeDocumentVersion = t3;
  let t4;
  if ($[5] !== isFixtureData || $[6] !== t) {
    t4 = isFixtureData && <InlineAlert variant="info">{t(_temp)}</InlineAlert>;
    $[5] = isFixtureData;
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== document) {
    t5 = <ConfidenceScores document={document} />;
    $[8] = document;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== extractions || $[11] !== hasExtractionData) {
    t6 = hasExtractionData && <AgentExtractionData extractions={extractions} />;
    $[10] = extractions;
    $[11] = hasExtractionData;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== hasExtractionData || $[14] !== t6) {
    t7 = <AnimatedContainer isExpanded={hasExtractionData}>{t6}</AnimatedContainer>;
    $[13] = hasExtractionData;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = activeDocumentVersion ?? "";
  let t9;
  if ($[16] !== document.kind || $[17] !== t8 || $[18] !== vaultData) {
    t9 = <ExtractedDocumentData vault={vaultData} documentType={document.kind} activeDocumentVersion={t8} />;
    $[16] = document.kind;
    $[17] = t8;
    $[18] = vaultData;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== document) {
    t10 = <IdentityData document={document} />;
    $[20] = document;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== document || $[23] !== vaultData) {
    t11 = <RawJsonData vault={vaultData} document={document} />;
    $[22] = document;
    $[23] = vaultData;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t10 || $[26] !== t11 || $[27] !== t4 || $[28] !== t5 || $[29] !== t7 || $[30] !== t9) {
    t12 = <>{t4}{t5}{t7}{t9}{t10}{t11}</>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t4;
    $[28] = t5;
    $[29] = t7;
    $[30] = t9;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  return t12;
};
export default DrawerContent;
function _temp($) {
  return $.isFixtureAlert;
}